<script setup>
import StartupsModal from "@/components/startups/StartupsModal.vue";
import {ref, inject, watch} from "vue";
import startupsService from "@/services/startups.service";
import searchService from "@/services/search.service";

const startupsIds = inject('startupsIds');
const startups = ref([]);
const startupsModal = ref(null);
const showSimilar = ref(false);
const loading = ref(false);

watch(showSimilar, () => {
    getData();
})

async function getData() {
    loading.value = true;

    const {data} = await (
        showSimilar.value ?
            searchService.getSimilar({startupsIds: startupsIds.value}) :
            startupsService.getStartupsDataForModal(startupsIds.value)
    );

    startups.value = data;
    loading.value = false;
}

function open() {
    getData();
    startupsModal.value.open();
}

defineExpose({open});
</script>

<template>
    <StartupsModal
        ref="startupsModal"
        :startups="startups"
        :loading="loading"
    >
        <template #header>
            <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
                <h3 class="heading3">Showing {{startupsIds.length}} startups</h3>
                <div class="market-switcher market-switcher--similar m-0 ml-auto">
                    <input type="checkbox" v-model="showSimilar" class="custom-control-input" id="cci2">
                    <label for="cci2" class="custom-control-label"></label>
                    
                </div>

                <button @click="startupsModal.close()" class="close"></button>
            </div>
        </template>
    </StartupsModal>
</template>

<style scoped>

</style>
